import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['hiddenAmount', 'customInput', 'customCollapse']

  connect() {
    const checkedRadio = this.element.querySelector('input[name="amount_selection"]:checked')
    if (checkedRadio && checkedRadio.value !== 'custom') {
      this.hiddenAmountTarget.value = checkedRadio.value
    }
  }

  selectPreset(event) {
    const amount = event.target.value
    this.hiddenAmountTarget.value = amount
    this.customInputTarget.value = ''
    this.customCollapseTarget.classList.add('d-none')
  }

  selectCustom() {
    this.customCollapseTarget.classList.remove('d-none')
  }

  updateCustom() {
    this.hiddenAmountTarget.value = this.customInputTarget.value
    this.element.querySelectorAll('input[name="amount_selection"]').forEach(r => r.checked = false)
  }
}
